<template>
  <v-alert :value="true" :color="color" :class="['my-4', 'unselectable']" :dismissible="dismissible" :icon="icon" :outline="outline">{{ message }}</v-alert>
</template>
<script>
export default {
  name: 'Warning',
  props: {
    color: {
      type: String,
      required: false,
      default: 'orange'
    },
    message: {
      type: String,
      required: true
    },
    outline: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      required: false,
      default: 'mdi-information-outline'
    },
    dismissible: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/warning.vue